/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authagreementand2Inputs */



/**
* | output |
* | --- |
* | "and" |
*
* @param {Authagreementand2Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const authagreementand2 = /** @type {((inputs?: Authagreementand2Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authagreementand2Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ ("and")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ ("et la")
	if (locale === "de-DE") return /** @type {LocalizedString} */ ("und unserer")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("和")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("및")
	return /** @type {LocalizedString} */ ("および")
});
export { authagreementand2 as "authAgreementAnd" }